import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    modalOverlay: {
      flex: 1,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      justifyContent: 'flex-end',
    },
    modalContainer: {
      backgroundColor: theme.colors.white,
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
      paddingBottom: 34, // Safe area bottom
    },
    modalHeader: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.lg,
      borderBottomWidth: 1,
      borderBottomColor: theme.colors.lightGrey,
    },
    modalTitle: {
      color: theme.colors.secondary,
      fontSize: theme.fontSize.large,
      fontWeight: 'bold',
    },
    closeButton: {
      padding: theme.spacing.xs,
    },
    actionsContainer: {
      paddingHorizontal: theme.spacing.lg,
    },
    actionItem: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: theme.spacing.lg,
    },
    actionItemBorder: {
      borderBottomWidth: 1,
      borderBottomColor: theme.colors.lightGrey,
    },
    actionItemDivider: {
      borderBottomWidth: 2,
      borderBottomColor: theme.colors.grey,
      marginVertical: theme.spacing.xs,
    },
    actionLabel: {
      marginLeft: theme.spacing.md,
      color: theme.colors.secondary,
      fontSize: theme.fontSize.medium,
    },
    pinnedContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: theme.spacing.sm,
    },
    pinButton: {
      marginHorizontal: theme.spacing.xs,
      padding: theme.spacing.xs,
    },
  })

export default getStyle 